export const useSlugify = () => {
  const slugify = (text: string): string => {
    return text.toLowerCase().replace(/\s+/g, '_');
  };

  return {
    slugify,
  };
};
